/**
 * Success Modal configuration
 */
export const modalConfig = {
  maxWidth: {
    mobile: 320,
    desktop: 400,
  },
  buttonHeight: {
    mobile: 34,
  },
};

/**
 * Warranty options
 */
export const warrantyOptions = [
  {
    id: "standard",
    label: "0 - 1 Year",
    value: false,
    description: "Standard warranty",
  },
  {
    id: "extended",
    label: "1 - 2 Yr (Ext)",
    value: true,
    description: "Extended warranty",
  },
];

/**
 * Modal content text
 */
export const modalContent = {
  title: "Thank you for submitting your details.",
  subtitle: "Warranty is successfully registered!",
  description:
    "Every Corvell product comes with a standard 1 year warranty. You can extend your warranty to 2 years at a discounted price!",
  nextButton: "Next",
};
